const constants = {
  user: {
    session: 'SESSION_USER',
  },
};

export default constants;
